import {ApiDetail, ApiList, BaseListModel, BaseModel} from "../lib/model";
import {CardList} from "./Card";
import {joinUrls} from "@/lib/funclib";

export class StackStatus extends BaseModel{
    id;
    lastSeen;
    level0Count;
    level1Count;
    level2Count;
    seenToday;
    level;

    constructor(data) {
        super();
        this.api.dateFields = ['lastSeen'];
        if (data instanceof Object) {
            this.modelCopy(data);
        }
    }
}

export class Stack extends BaseModel {

    id;
    name;
    description;
    cards;
    legacyId;
    cardCount;
    order;
    public;
    status;
    createdBy;
    createdDate;
    modifiedBy;
    modifiedDate;

    api = new class extends ApiDetail {
        url = '/stack/:pk/';
        dateFields = ['createdDate', 'modifiedDate'];
        updateFields = ['name', 'description', 'public'];
        quizCards;

        fetchQuizList(level) {
            let url = '/stack/:pk/';
            let quiz = 'quiz';
            if (level === -1) {
                quiz = 'quiz_all'
            } else if (level === 1) {
                quiz = 'quiz_short';
            } else if (level === 2) {
                quiz = 'quiz_long';
            } else if (level === 3) {
                quiz = 'quiz_algorithm';
            }
            url = joinUrls(url, quiz);
            this.quizCards = new CardList();
            return this.quizCards.api.fetch(this.parent.id, url);
        }
    }(this);
    constructor(data) {
        super();
        if (data instanceof Object) {
            this.modelCopy(data);
        }
    }
    modelCopy(data) {
        super.modelCopy(data);
        if (this.cards instanceof Array) {
            this.cards = new CardList(this.cards);
        }
        if (this.status instanceof Object) {
            this.status = new StackStatus(this.status);
        }
    }
}

export class StackList extends BaseListModel {
    api = new class extends ApiList {
        url = '/stack/';
    }(this);
    constructor(stacks) {
        super();

        if (stacks instanceof Array) {
            this.modelCopy(stacks);
        }
    }
    pushItem(item) {
        super.pushItem(new Stack(item));
    }
}
